import { useState } from 'react';
import { BsCreditCard } from 'react-icons/bs';
import { TiDelete } from 'react-icons/ti';
import { Loading } from '../loading';
import { useGlobal } from '../../state';

export const CardDisplay = () => {
  const { user, refreshUser, fox } = useGlobal();
  const [loading, setLoading] = useState();
  const last4 = user?.paymentMethodLast4;

  const handleDelete = async (e) => {
    e.preventDefault();
    console.log('delete card', user, last4);

    setLoading(true);
    await fox.call('DELETE', '/api/user/stripe/card');
    await refreshUser();
    setLoading(false);
  };

  return (
    <div
      style={{
        borderRadius: 8,
        padding: '8px 12px',
        background: '#eee',
        display: 'flex',
        gap: 8,
        alignItems: 'center',
        justifyContent: 'space-between',
        fontSize: '90%',
        fontWeight: 'bold',
        width: 200,
      }}
    >
      <BsCreditCard size={20} />
      <div>{last4 ? <>&bull; &bull; &bull; &bull; {last4}</> : 'Unknown card'}</div>
      {loading ? <Loading size="sm" /> : <TiDelete style={{ cursor: 'pointer' }} size={20} onClick={handleDelete} />}
    </div>
  );
};
